<template>
  <div>
    <base-header class="pb-4" />

    <div class="container-fluid mt--4">
      <b-card class="mb-4">
        <b-tabs v-if="user" v-model="tab" pills card vertical class="custom-tabs" >
          <b-tab :title="$t('Firma Bilgileri')" :active="user.first_user" v-if="user.first_user">
            <template v-if="tab === 0">
              <company-settings :cities="cities" />
            </template>
          </b-tab>
          <b-tab :title="$t('Kullanıcı Bilgileri')" :active="!user.first_user">
            <template v-if="tab === !user.first_user ? 0 : 1 ">
              <user-settings :user="componentUser" @save-changes="saveUserSettings"></user-settings>
            </template>
          </b-tab>
          <b-tab :title="$t('SMS Ayarları')" v-if="user.first_user">
            <template v-if="tab === !user.first_user ? 1 : 2 ">
              <sms-settings />
            </template>
          </b-tab>
          <b-tab :title="$t('Şifreyi Değiştir')">
            <template v-if="tab === !user.first_user ? 2 : 3 ">
              <change-password :user="componentUser" />
            </template>
          </b-tab>

          <b-tab :title="$t('Kullanıcılar')" v-if="user.first_user">
            <template v-if="tab === 4">
              <users :companyid="user.company.id"></users>
            </template>
          </b-tab>
        </b-tabs>
        <div v-else class="w-100 text-center">
          <b-spinner variant="default" />
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";

  import CompanySettings from "./CompanySettings";
  import SMSSettings from "./SMSSettings";
  import UserSettings from "./UserSettings";
  import ChangePassword from "./ChangePassword";
  import users from "../system-management/companies/components/Users";

  export default {
    name: "Settings",
    components: {
      CompanySettings,
      UserSettings,
      ChangePassword,
      'sms-settings': SMSSettings,
      users
    },
    computed: {
      ...mapGetters(["user"]),
      componentUser() {
        return this.user ? JSON.parse(JSON.stringify(this.user)) : null;
      }
    },
    data() {
      return {
        cities: null,
        tab: 0,
      };
    },
    methods: {
      ...mapActions(['setUser', 'getCities', 'updateUserSettings']),
      setLogo(url) {
        const currentUser = JSON.parse(JSON.stringify(this.user));
        currentUser.company.logo_url = url;
        this.setUser(currentUser);
      },
      saveUserSettings() {
        this.updateUserSettings(this.componentUser)
          .then(response => {
            this.setUser(this.componentUser);
            this.success(response.data.message);
          }).catch(error => {
            this.error(error.response.data.message);
          });
      },
    },
    mounted() {
      this.getCities().then(response => {
        this.cities = response.data;
      });
    },
  };
</script>
